import { Box, Divider, Text, Image } from '@chakra-ui/react';
import React from 'react';
import ArrowRightIcon from '../../assets/Icons/arrowRight';
import { useNavigate } from 'react-router-dom';
import { SimilarProject } from '../../interfaces/components';

interface PotentialInvestorsTabProps {
  similarProject: SimilarProject[];
}

export default function SimilarProjectTab(props: PotentialInvestorsTabProps) {
  const { similarProject } = props;

  const navigate = useNavigate();

  const onExploreClick = async (id: any) => {
    navigate(`/project/${id}`);
  };

  return (
    <>
      <Box marginTop="28px">
        <Text fontSize={'24px'} fontWeight={600} color="#000">
          Similar Projects
        </Text>
        <Text fontSize={'14px'} fontWeight={400} color="rgba(0, 0, 0, 0.50)" marginTop="10px">
          These are investors that have backed related projects.
        </Text>
        <Box mt="32px" display="flex" gap="18px" flexWrap="wrap">
          {similarProject &&
            similarProject?.length > 0 &&
            similarProject.map((item: any, index: React.Key | null | undefined) => (
              <Box
                borderRadius="12px"
                border="1px solid rgba(0, 0, 0, 0.10)"
                background="#FFF"
                padding="24px"
                key={index}
                width={{ base: '100%', md: 'calc(50% - 9px)' }} // Adjusting width based on screen size
                cursor="pointer"
              >
                <Box display="flex" alignItems="center" gap="7px">
                  <Box>
                    <Image
                      src={item.logo}
                      alt="Dan Abramov"
                      width="36px"
                      height="36px"
                      borderRadius="50%"
                      referrerPolicy="no-referrer"
                    />
                  </Box>
                  <Text color=" rgba(0, 0, 0, 0.85)" fontSize="17px" fontWeight="600">
                    {item?.project_name}
                  </Text>
                </Box>
                <Text color="rgba(0, 0, 0, 0.50)" fontSize="12px" fontWeight="600" mt="12px" mb={'20px'}>
                  {item?.brief_description}
                </Text>
                <>
                  <Divider />
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt="10px"
                    alignItems="center"
                    onClick={() => onExploreClick(item?.project_id)}
                  >
                    <Text color="#5772FF" fontSize="14px" fontWeight="600">
                      Explore {item?.project_name}
                    </Text>
                    <ArrowRightIcon />
                  </Box>
                </>
              </Box>
            ))}
        </Box>
      </Box>
    </>
  );
}
